import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { Tag, Button } from 'antd';
import queryString from 'query-string';
import {
  fetchOrdersAC,
  ordersDataSelector,
  fetchOrdersErrorSelector,
  isFetchingOrdersSelector,
  totalOrdersSelector,
  currentPageSelector,
  pageSizeSelector,
} from '../../apiCalls/orders/list';
import { completeOrderAC } from '../../apiCalls/orders/complete';
import { cancelOrderAC } from '../../apiCalls/orders/cancel';
import {
  orderStatusConfig,
  orderStatusColors,
  shippingMethodConfig,
} from '../../utils/constants';
import ErrorMessage from '../shared/ErrorMessage';
import DataTable from '../shared/DataTable';
import PageTitle from '../shared/PageTitle';
import { formatDate, timeAgo } from '../../utils/formatDate';

const columnsGenerator = () => [
  {
    title: 'Created at',
    dataIndex: 'created',
    render: value => formatDate(value),
  },
  {
    title: 'Last update',
    dataIndex: 'modified',
    render: value => timeAgo(value),
  },
  {
    title: 'Buyer',
    dataIndex: ['buyer', 'name'],
  },
  {
    title: 'Seller',
    dataIndex: ['seller', 'name'],
  },
  {
    title: 'Price',
    dataIndex: 'price',
    render: price => `RM${price}`,
    align: 'right',
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    align: 'right',
  },
  {
    title: 'Shipping',
    dataIndex: 'shipping_method',
    render: shipping_method => shippingMethodConfig[shipping_method],
  },
  {
    title: 'Total Amount',
    dataIndex: 'total_amount',
    render: total_amount => `RM${total_amount}`,
    align: 'right',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    render: status => (
      <Tag color={orderStatusColors[status]}>{orderStatusConfig[status]}</Tag>
    ),
  },
  {
    title: 'Action',
    dataIndex: 'id',
    render: id => (
      <Button>
        <Link to={`/emarket/orders/${id}`}>Detail</Link>
      </Button>
    ),
  },
];

const Orders = ({ fetchOrders, orders, loading, error, ...others }) => {
  const location = useLocation();
  const params = queryString.parse(location.search);

  useEffect(() => {
    fetchOrders(params);
    // eslint-disable-next-line
  }, [location, fetchOrders]);

  return (
    <>
      <PageTitle content="Orders" />
      {error && <ErrorMessage />}
      <DataTable
        dataSource={orders}
        dataFetcher={fetchOrders}
        loading={loading}
        filters={params}
        {...others}
      />
    </>
  );
};

const connectToRedux = connect(
  state => ({
    orders: ordersDataSelector(state),
    loading: isFetchingOrdersSelector(state),
    error: fetchOrdersErrorSelector(state),
    totalItems: totalOrdersSelector(state),
    currentPage: currentPageSelector(state),
    pageSize: pageSizeSelector(state),
    columns: columnsGenerator(),
  }),
  {
    fetchOrders: fetchOrdersAC,
    completeOrder: completeOrderAC,
    cancelOrder: cancelOrderAC,
  }
);

export default connectToRedux(Orders);
